import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ScrollService {
  /**
   *
   * @param nativeElement "nativeElement" of your viewchild
   * @param topOffset number of pixel offset on top to be below the top navigation on mobile (65px)
   */
  scrollIntoView(nativeElement: HTMLElement, scrollContainer: Element | Window = window, topOffset = 65) {
    this.scrollBy(nativeElement.getBoundingClientRect().top, scrollContainer, topOffset);
  }

  scrollTo(position: number, scrollContainer: Element | Window, topOffset = 65) {
    if (scrollContainer instanceof Window) {
      const pos = window.pageYOffset + position - topOffset;
      window.scrollTo({
        top: pos > 0 ? position : 0,
        behavior: 'smooth'
      });
    } else {
      scrollContainer.scrollTo({ top: position + topOffset, left: 0, behavior: 'smooth' });
    }
  }

  /**
   * scolling bugs with elements that toggle and change their heights? Try avoiding absolute scrolling
   * but use relative one. See checkout page mobile binding settings
   * @param nativeElement
   * @param topOffset
   */
  scrollBy(position: number, scrollContainer: Element | Window, topOffset = 65) {
    const by = position - topOffset;
    scrollContainer.scrollBy({
      top: by,
      behavior: 'smooth'
    });
  }
}
